import { render, staticRenderFns } from "./review-analysis-panel.vue?vue&type=template&id=e9963c56&scoped=true&"
import script from "./review-analysis-panel.vue?vue&type=script&lang=js&"
export * from "./review-analysis-panel.vue?vue&type=script&lang=js&"
import style0 from "./review-analysis-panel.vue?vue&type=style&index=0&id=e9963c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9963c56",
  null
  
)

export default component.exports